<template>
    <div id="print" class="big_cat_screen">
        <div class="back_nav" @click="backNav()"><img src="../../assets/back_nav.png"/></div>

        <div v-if="showExitConfirm === 1" class="exit_transition">
            <div class="exit_content">
                <div class="exit_title">完成后，才可以获得星星哦</div>
                <div class="game_action">
                    <div class="game_quit" v-on:click.stop="gameQuitClick">
                        <img src="../../Images/game_quit.png"/>
                        <span>Quit</span>
                    </div>
                    <div class="game_continue" v-on:click.stop="gameContinueClick">
                        <img src="../../Images/game_continue.png"/>
                        <span>Continue</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <div class="div_icon">
                        <img id="success_icon" style="display: none" class="icon" src="@/Images/jiangbei.png"/>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="../../Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>亲子对话</span>
                            <img src="../../assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
            <audio class="audio" :src="greatAudio" id="great_audio"/>
        </div>

        <!-- 背景 -->
        <div>
            <audio v-show="false" :src="errorAudio" id="error_audio"/>
            <audio v-show="false" :src="successAudio" id="success_audio"/>

            <div class="left_back">
                <div class="result left_result"><span>{{leftAnswer}}</span></div>
                <div class="head"><img src="@/Images/icon_question.png" alt="" /></div>

                <div id="left_answer" class="answer">
                    <div :id="'option_left' + index" class="option_img_item" v-for="(item,index) in listOption" :key="index" @click="optionClick(item, index, 1)">
                        <div class="option_item">
                            <img class="lazy_img" v-lazy="$qiNiuDomainBase + item.picture" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="right_back">
                <div class="result right_result"><span>{{rightAnswer}}</span></div>
                <div class="head"><img src="@/Images/icon_answer.png" alt="" /></div>

                <div id="right_answer" class="answer">
                    <div :id="'option_right' + index" class="option_img_item" v-for="(item,index) in listOption" :key="index" @click="optionClick(item, index, 2)">
                        <div class="option_item">
                            <img class="lazy_img" v-lazy="$qiNiuDomainBase + item.picture" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="center_vs"><img src="@/Images/icon_vs.png" alt="" /></div>
            <div class="question" @click="playAudio()">
                <div class="text">{{questionText}}</div>

                <div class="audio_playing_white img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                <img class="img_play" :style="{display: isPlaying ? 'none' : ''}" src="@/assets/volume_white.png" height="30" width="30"/>
                <audio v-show="false" :src="audioUrl" @ended="playEnded" id="musicMp3" controls=""></audio>
            </div>
        </div>

    </div>
</template>

<script>
    import $ from "jquery";
    import Utils from '@/pages/Program/util2.js';

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                lessonId: 0,
                currentIndex: 0,
                listCourseQuestion: [],
                listOption: [],
                audioUrl: "",
                questionText: "",
                leftAnswer: 0,
                rightAnswer: 0,
                checkRightAnswer: false,
                isPlaying: false,
                errorAudio: "https://img.xiaohuasheng.cn/error_tip.mp3",
                successAudio: "https://img.xiaohuasheng.cn/success.mp3",
                showExitConfirm: 0,
                showTransition: false,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
                fromPage: 0,
            }
        },
        methods: {
            nextPageClick() {
                this.$router.replace({name: "PPrepareDialogue", query: {lessonId: this.lessonId, fromPage: this.fromPage}});
            },
            backNav:function(){
                this.showExitConfirm = 1;
            },
            gameQuitClick() {
                this.showExitConfirm = 0;
                this.$router.go(this.fromPage=== 1 ? -2 : -1);
            },
            gameContinueClick() {
                this.showExitConfirm = 0;
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            showStatus:function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            getStateHeight: function () {
                return this.getCount(this.$store.state.statusheight);
            },
            optionClick: function (item, index, isLeftRight) {
                let that = this;

                if (that.checkRightAnswer) {
                    return;
                }

                that.checkRightAnswer = true;
                if (that.currentIndex < that.listCourseQuestion.length - 1) {
                    $(".option_item").hide(500);
                }

                let leftResult = $(".left_result").find("span");
                let rightResult = $(".right_result").find("span");

                if (item.isRightAnswer === 1) {
                    // 播放正确音
                    that.playSuccessAudio();

                    if (isLeftRight === 1) {
                        that.leftAnswer += 1;
                        leftResult.hide();
                        leftResult.show(1000);
                    } else {
                        that.rightAnswer += 1;
                        rightResult.hide();
                        rightResult.show(1000);
                    }
                } else {
                    // 播放错误音
                    that.playErrorAudio();

                    if (isLeftRight === 1) {
                        that.rightAnswer += 1;
                        rightResult.hide();
                        rightResult.show(1000);
                    } else {
                        that.leftAnswer += 1;
                        leftResult.hide();
                        leftResult.show(1000);
                    }
                }

                that.listOption = [];

                setTimeout(function () {
                    if (that.currentIndex < that.listCourseQuestion.length - 1) {
                        that.currentIndex += 1;

                        let vQuestion = that.listCourseQuestion[that.currentIndex];
                        that.listOption = vQuestion.optionArray;
                        that.audioUrl = that.$qiNiuDomainBase + vQuestion.audio;
                        that.questionText = vQuestion.word;
                        that.isPlaying = true;

                        setTimeout(() => {
                            $(".option_item").show(1000);
                            that.checkRightAnswer = false;
                            that.playAudio();
                        }, 200);
                    } else {
                        // 最后一题
                        that.showTransition = true;
                        Utils.$emit('setStarCount','1');

                        setTimeout(function () {
                            const greatAudio = document.getElementById('great_audio');
                            greatAudio.play();
                            $("#success_icon").show(800, function(){});
                        }, 20);
                    }
                }, 500);
            },
            playErrorAudio() {
                const errorAudio = document.getElementById('error_audio');
                errorAudio.play();
            },
            playSuccessAudio() {
                const successAudioPlay = document.getElementById('success_audio');
                successAudioPlay.play();
            },
            playAudio() {
                let that = this;
                let musicMp3 = document.getElementById('musicMp3');
                let playPromise = musicMp3.play();

                if (playPromise !== undefined) {
                    that.isPlaying = true;

                    playPromise.then(() => {
                    }).catch((e) => {
                        let vError = JSON.stringify(e);
                        that.isPlaying = false;

                        if (!that.isEmpty(vError) && vError !== "{}") {
                            window.console.log("播放失败:playAudio:" + JSON.stringify(e));
                        }
                    });
                } else {
                    that.isPlaying = false;
                    window.console.log("播放失败:playAudio");
                }
            },
            playEnded() {
                var musicMp3 = document.getElementById('musicMp3');
                this.isPlaying = false;

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(that.$route.query.lessonId);
            let vFromPage = parseInt(that.$route.query.fromPage);
            let url = "/englishProgram/getParentChildPK/" + vLessonId;

            that.$axios.get(url).then((response) => {
                that.listCourseQuestion = response.data;
                that.lessonId = vLessonId;
                that.fromPage = vFromPage;

                if (!that.isEmpty(that.listCourseQuestion)) {
                    let vQuestion = that.listCourseQuestion[0];
                    that.listOption = vQuestion.optionArray;
                    that.audioUrl = that.$qiNiuDomainBase + vQuestion.audio;
                    that.questionText = vQuestion.word;
                    that.isPlaying = true;

                    setTimeout(() => {
                        that.playAudio();
                        that.showStatus(0);
                    }, 200);
                }

                setTimeout(() => {
                    transformView();
                }, 200);

            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .left_back {
        position: absolute;
        left: 0;
        top: 0;
        background-color: #333333;
        width: 50%;
        height: 100%;
    }
    .result {
        position: absolute;
        top: 0;
        width: 70px;
        height: 70px;
        background-color: white;
        left: 50%;
        -webkit-transform: translateX(-50%);
        font-size: 35px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .left_result span {
        width: 70px;
        height: 70px;
        line-height: 70px;
        color: #333333;
        text-align: center;
    }
    .right_result span {
        width: 70px;
        height: 70px;
        line-height: 70px;
        color: #ff505a;
        text-align: center;
    }

    .right_back {
        position: absolute;
        right: 0;
        top: 0;
        background-color: #ff505a;
        width: 50%;
        height: 100%;
    }

    .center_vs {
        position: absolute;
        top: 0;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .center_vs img {
        width: 60px;
        height: 60px;
        margin-top: 10px;
    }
    .head {
        position: absolute;
        top: 75px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .head img {
        width: 50px;
        height: 50px;
    }
    .question {
        position: absolute;
        width: 160px;
        height: 90px;
        left: 50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
        background-color: #005e34;
        border: 5px solid white;
        border-radius: 5px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
    }
    .question .text {
        width: 160px;
        margin: 0;
        padding: 0;
        text-align: center;
        font-size: 25px;
        font-weight: bold;
        color: #fdfcc9;
    }
    .question .img_play {
        margin-top: -10px;
    }

    .answer {
        width: 50%;
        position: absolute;
        left: 50%;
        -webkit-transform: translateX(-50%);
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .answer .option_item {
        width: 94px;
        height: 94px;
        margin: 3px;
        background-color: #FFB500;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }
    .answer .option_img_item .lazy_img {
        width: 90px;
        height: 90px;
        margin: 2px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }

    .big_cat_screen .exit_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .big_cat_screen .exit_content {
        position:relative;
    }
    .big_cat_screen .exit_content .exit_title {
        color: white;
        font-size: 18px;
        text-align: center;
        margin-bottom: 50px;
    }
    .big_cat_screen .exit_content .game_action .game_quit {
        display: inline-block;
        margin-right: 100px;
    }
    .big_cat_screen .exit_content .game_action .game_continue {
        display: inline-block;
    }
    .big_cat_screen .exit_content .game_action .game_quit img, .big_cat_screen .exit_content .game_action .game_continue img {
        display: block;
        width: 70px;
        margin-bottom: 10px;
    }
    .big_cat_screen .exit_content .game_action .game_quit span, .big_cat_screen .exit_content .game_action .game_continue span {
        display: block;
        text-align: center;
        font-size: 20px;
        color: white;
    }
    .big_cat_screen .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .big_cat_screen .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .big_cat_screen .transition .content2 {
        text-align: center;
    }

    .big_cat_screen .transition .content3 {
        text-align: center;
    }
    .big_cat_screen .transition .content .div_icon {
        margin-bottom: 10px;
        width: 100%;
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .big_cat_screen .transition .content .div_icon .icon {
        width: 136px;
        height: 150px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }
</style>
